import React from "react";

/**
 * Animated themed background — hexagonal honeycomb circuit-board grid with
 * pulsing nodes, drifting glow particles, and a slow vertical scan line.
 * Matches the brand aesthetic of the StrainScan Pro logo.
 */
export default function Background() {
  // Static random positions (no re-renders).
  const nodes = [
    [10, 18], [28, 42], [44, 12], [62, 36], [78, 22],
    [88, 58], [16, 64], [34, 80], [52, 70], [70, 84],
    [6, 92], [40, 96], [82, 88], [94, 12], [58, 6],
  ];
  const particles = Array.from({ length: 30 }, (_, i) => ({
    left: (i * 73) % 100,
    top: (i * 47 + 13) % 100,
    delay: (i % 12) * 0.8,
    duration: 18 + (i % 7) * 3,
  }));

  return (
    <div
      className="ss-bg-root"
      data-testid="site-background"
      aria-hidden="true"
    >
      <div className="ss-bg-base" />
      <div className="ss-bg-hex" />
      <div className="ss-bg-hex ss-bg-hex--shift" />
      <div className="ss-bg-glow ss-bg-glow--a" />
      <div className="ss-bg-glow ss-bg-glow--b" />

      {/* Pulsing nodes */}
      <div className="ss-bg-nodes">
        {nodes.map(([x, y], i) => (
          <span
            key={i}
            className="ss-bg-node"
            style={{
              left: `${x}%`,
              top: `${y}%`,
              animationDelay: `${(i % 6) * 0.6}s`,
            }}
          />
        ))}
      </div>

      {/* Drifting particles */}
      <div className="ss-bg-particles">
        {particles.map((p, i) => (
          <span
            key={i}
            className="ss-bg-particle"
            style={{
              left: `${p.left}%`,
              top: `${p.top}%`,
              animationDelay: `${p.delay}s`,
              animationDuration: `${p.duration}s`,
            }}
          />
        ))}
      </div>

      {/* Vertical scan beam */}
      <div className="ss-bg-scanbeam" />

      {/* Subtle vignette to keep content readable */}
      <div className="ss-bg-vignette" />
    </div>
  );
}
